import type { GetIssueAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIssueAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIssueAuditByIdArgs = {
  id: string;
};

export const useGetIssueAuditById = createQueryHook<
  UseGetIssueAuditByIdArgs,
  GetIssueAuditByIdResponseRow[],
  GetIssueAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIssueAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ issue_audit: data }),
  graphqlDocument: GetIssueAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
